// extracted by mini-css-extract-plugin
export default {"zoomCom":"Zoom__zoomCom___h5sqH"};